const SECTORS = [
  {
    icon: "ri-star-smile-line",
    name: "圈内",
    en: "CELEBRITY",
    desc: "演员歌手、团队运作、粉丝生态",
    count: "386 条",
    color: "bg-primary-100 text-primary-700",
    bar: "bg-primary-500",
  },
  {
    icon: "ri-building-line",
    name: "商界",
    en: "BUSINESS",
    desc: "创始人、资本、职业经理人动向",
    count: "212 条",
    color: "bg-accent-100 text-accent-800",
    bar: "bg-accent-500",
  },
  {
    icon: "ri-tv-2-line",
    name: "综艺",
    en: "VARIETY",
    desc: "录制现场、剪辑、嘉宾互动",
    count: "175 条",
    color: "bg-secondary-100 text-secondary-800",
    bar: "bg-secondary-600",
  },
  {
    icon: "ri-gamepad-line",
    name: "电竞·游戏",
    en: "ESPORTS",
    desc: "选手转会、战队运营、主播",
    count: "140 条",
    color: "bg-primary-100 text-primary-700",
    bar: "bg-primary-400",
  },
  {
    icon: "ri-run-line",
    name: "体育",
    en: "SPORTS",
    desc: "球员言论、俱乐部人事变动",
    count: "96 条",
    color: "bg-accent-100 text-accent-800",
    bar: "bg-accent-400",
  },
  {
    icon: "ri-camera-lens-line",
    name: "网红·直播",
    en: "INFLUENCER",
    desc: "带货翻车、涨粉套路、MCN 纠纷",
    count: "288 条",
    color: "bg-secondary-100 text-secondary-800",
    bar: "bg-secondary-500",
  },
];

export default function Sectors() {
  return (
    <section id="sectors" className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="text-center mb-8">
          <p className="flex items-center justify-center gap-2 text-[13px] font-semibold text-primary-600 tracking-wide">
            <span className="w-1.5 h-3 rounded-sm bg-primary-500" /> BY SECTOR
          </p>
          <h2 className="mt-2 font-heading text-[28px] md:text-[36px] font-black text-foreground-950">按题材分栏翻</h2>
          <p className="mt-2 text-[14px] text-foreground-500">想直接看你关注的那片，点对应分区即可，新近合集也已同步归档。</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {SECTORS.map((s) => (
            <a
              key={s.name}
              href="#hot"
              className="group bg-background-100/60 border border-background-200 rounded-lg p-5 hover:bg-background-100 hover:border-primary-200 transition-all"
            >
              <div className="flex items-center gap-4">
                <span className={`w-12 h-12 rounded-lg flex items-center justify-center ${s.color}`}>
                  <i className={`${s.icon} w-6 h-6 flex items-center justify-center`} />
                </span>
                <div>
                  <h3 className="font-heading text-[18px] font-bold text-foreground-950">{s.name}</h3>
                  <p className="text-[11px] tracking-widest text-foreground-400 font-semibold">{s.en}</p>
                </div>
                <span className="ml-auto inline-flex items-center gap-1 text-[13px] text-foreground-400">
                  {s.count} <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:text-primary-600 transition-colors" />
                </span>
              </div>
              <div className="mt-4 h-1 rounded-full bg-background-200 overflow-hidden">
                <div className={`h-full w-2/3 rounded-full ${s.bar}`} />
              </div>
              <p className="mt-3 text-[13px] text-foreground-500">{s.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}